import type { UserHabit, HabitActions } from "../types";
export default function habits(
  state: {
    habits: UserHabit[];
    isLoaded: boolean;
  } = {
    habits: [],
    isLoaded: false,
  },
  action: HabitActions
): {
  habits: UserHabit[];
  isLoaded: boolean;
} {
  switch (action.type) {
    case "LOAD_HABITS_SUCCEEDED":
      return {
        habits: action.installedHabits,
        isLoaded: true,
      };

    case "STORE_HABITS_SUCCEEDED":
      return {
        habits: action.installedHabits,
        isLoaded: true,
      };
  }

  return state;
}
